import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {CompanyCodesListHeader} from './components/header/CompanyCodesListHeader'
import {CompanyCodesTable} from './table/CompanyCodesTable'
import {CompanyCodeEditModal} from './companycode-edit-modal/CompanyCodeEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const CompanyCodesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <CompanyCodesListHeader />
        <CompanyCodesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <CompanyCodeEditModal />}
    </>
  )
}

const CompanyCodesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <CompanyCodesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {CompanyCodesListWrapper}
